//CanceledService.ts
import { axiosRequest } from "./AxiosService";
import { ApplicationData } from "../pages/RecordDetail/ApplicationData";

/**
 * 進行中のアクティビティIDを取得する
 * - 全アクティビティが未開始の場合は順序1のアクティビティIDを返す
 * @param applicationData - 申請データ
 * @returns 対象のアクティビティID、存在しない場合はnull
 */
export const getCurrentActivityId = (applicationData: ApplicationData) => {
  if (
    !applicationData.activityList ||
    applicationData.activityList.length === 0
  ) {
    return null;
  }

  // activityList内のアクティビティステータスが全てNotStartedだった場合、Orderが1のアクティビティIDを返す
  const allNotStarted = applicationData.activityList.every(
    (activity) => activity.status === "NotStarted"
  );  
  if(allNotStarted){
    const activityId = applicationData.activityList.find(
      (activity) => activity.order === 1
    )?.activityId;
    return activityId;
  }

  // 申請ステータスは進行中のアクションを見つけ出す
  const activityId = applicationData.activityList.find(
    (activity) => activity.status === "InProgress"
  )?.activityId;

  // 該当するアクティビティが存在しない場合
  if (!activityId) {
    console.warn("進行中のアクティビティが存在しません。");
  }

  return activityId || null;
};

/**
 *  取り下げ処理（CanceledService）
 * ログイン中のユーザーID（userId）と進行中のアクティビティID（activityId）を獲得。
 * @param userId - 現在のユーザーのID
 * @param applicationData - 進行中のアクティビティを特定するために使用される。
 */

export const canceled = async (
  userId: string,
  applicationData: ApplicationData,
  comment: string
): Promise<boolean> => {
  // ログイン中のuserIdと進行中のactivityIdを獲得
  const applicationEntryId = applicationData.applicationEntryId;

  // userIdとactivityIdを獲得できない場合
  if (!userId || !applicationEntryId) {
    console.error("ユーザーIDまたはアクティビティIDが無効です");
    return false;
  }

  // 引数を設定する
  const options = {
    data: {
      applicationEntryId: applicationEntryId,
      comment: comment,
    },
  };

  try {
    // サーバー通信
    const response: Promise<boolean> = axiosRequest(
      "/canceled",
      "POST",
      options
    );

    if (response !== undefined) {
      return (await response).valueOf();
    } else {
      return false;
    }
  } catch (error) {
    console.error("取り下げ処理のリクエストエラー:", error);
    return false;
  }
};
